import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import {
  TextVariant,
  TypographyNew,
} from "../../product/global/typography/typography";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { useBreakpoint } from "../../product/utils/hooks";

type TopbarMenuProps = {
  items?: Array<{ title: string; description: string; link: string }>;
  title: string;
  link?: string;
};

const Container = styled.ul`
  background: ${(props) => props.theme.colors.white};
  padding: 0;
  margin: 0;
  list-style: none;
  display: grid;
  grid-template-columns: 1fr;
  top: 40px;

  @media (min-width: 1280px) {
    max-width: 500px;
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
    border: 1px solid ${(props) => props.theme.colors.grays4};
    top: 50px;
    border-radius: ${(props) => props.theme.borderRadius.small};
    position: absolute;
    padding: 30px;
    padding-top: 10px;

    &:hover {
      li {
        opacity: 0.7;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
`;

const ListItem = styled.li`
  border-bottom: 2px solid #e1eaf0;
  cursor: pointer;
  padding-bottom: 10px;
  margin-left: -30px;
  padding-left: 50px;
  background: ${(props) => props.theme.colors.misc3};
  padding-top: 20px;

  :hover {
    opacity: 1;
  }

  @media (min-width: 1280px) {
    background: none;
    border-bottom: 1px solid #dadce0;
    padding-bottom: 20px;
    margin-left: 0;
    padding-left: 0;

    &:nth-last-child(-n + 2) {
      border-bottom: none;
      padding-bottom: 0;
    }
  }
`;

const TopbarMenuItem = styled.div`
  color: black;
  padding: 20px;
  cursor: pointer;
  font-family: ${(props) => props.theme.fonts.normal};
  font-size: 18px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  &:hover {
    color: ${(props) => props.theme.colors.primary1};
    cursor: pointer;
  }

  @media (min-width: 1280px) {
    display: block;
  }
`;

const MenuIcon = styled(FontAwesomeIcon)`
  margin-left: 10px;
`;

const TopbarItem = (props: TopbarMenuProps): JSX.Element => {
  const history = useHistory();
  const theme = useTheme();
  const { isDesktop } = useBreakpoint();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <TopbarMenuItem
        onTouchStart={() => {
          if (!isDesktop && props.items) {
            setIsOpen(!isOpen);
          }
        }}
        onClick={() => {
          if (props.link) {
            history.push(props.link);
          }
        }}
      >
        {props.title}
        {!!props.items?.length && (
          <MenuIcon size="xs" icon={isOpen ? faChevronUp : faChevronDown} />
        )}
      </TopbarMenuItem>
      {!!props.items?.length && isOpen && (
        <Container>
          {props.items?.map((item) => (
            <ListItem onClick={() => history.push(item.link)} key={item.title}>
              <TypographyNew
                marginBottom="10px"
                variant={TextVariant.h5}
                color={theme.colors.primary1}
              >
                {item.title}
              </TypographyNew>
              {isDesktop && (
                <TypographyNew
                  color={theme.colors.grays2}
                  variant={TextVariant.subtitle1}
                >
                  {item.description}
                </TypographyNew>
              )}
            </ListItem>
          ))}
        </Container>
      )}
    </div>
  );
};

export default TopbarItem;
